export const startDownload = (url: string, filename?: string): void => {
    const virtualAnchor = document.createElement('a');
    virtualAnchor.href = url;
    virtualAnchor.target = '_blank';
    virtualAnchor.download = filename ?? '';
    virtualAnchor.click();
    virtualAnchor.remove();
};

export const isSpreadsheet = (filename: string) => filename.toLowerCase().includes('.xls');
